// External
import { CircularProgress } from '@mui/material';

export const Spinner = () => <CircularProgress size={60} />;
